import React, { Component } from "react";
import { Button, Modal, Dropdown, Header, Form } from "semantic-ui-react";
import { defaultPage } from "../constants";
import store from 'store2';

export default class DefaultPageModal extends Component {

  onDefaultChange(e, data) {
    const value = data.value;
    this.props.onChangeDefaultPage(e, { value })
    store.set('defaultPage', value);
  }

  render() {
    return (
      <Modal
        open={true}
        onClose={this.props.hideDefaultPageModal}
        centered={false}
        size='mini'
        className="modalOverflowUnset"
        closeIcon
      >
        <Header content='Default Landing Page' />
        <Modal.Content>
          <Form className="formStyle">
            <label className="mr10">Select Default Landing Page</label>
            <Dropdown className='mr10' fluid placeholder='Select Page' value={store.get('defaultPage')} selection options={defaultPage}
              onChange={(e, data) => this.onDefaultChange(e, data)} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button className="ui primary button float-right" onClick={this.props.onClickDefaultPage}>
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
